import {
    IonButton,
    IonButtons,
    IonCard,
    IonContent,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonSpinner,
    IonText,
    IonTitle,
    IonToolbar,
} from "@ionic/react";
import { trashOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";

import { setDeselectAllUsers, setDeselectUser } from "../../../store/formsubmitted";
import { selectFilterUserSelected } from "../../../store/formsubmitted/selectors/selectFilterUserSelected";
import { RootState } from "../../../store/rootReducer";
import { ConfirmButton } from "./ConfirmButton";
import { UserSelectedSearchBar } from "./UserSelectedSearchBar";

export const UserSelected = () => {
    const dispatch = useDispatch();
    const selectedUsers = useSelector((state: RootState) => state.formSubmittedSlice.selectedUsers);
    const filterSelectedUsers = useSelector(selectFilterUserSelected);
    const findAssignedUsersStatus = useSelector((state: RootState) => state.formSubmittedSlice.findAssignedUsersStatus)
 
    return (
        <IonCard style={{ height: "75vh" }} class="ion-no-margin">
            <IonToolbar color="primary">
                <IonTitle size="small" style={{ fontWeight: 500 }}>
                    Seleccionados ({selectedUsers.length})
                </IonTitle>
                <IonButtons slot="end">
                    {!!selectedUsers.length && (
                        <IonButton
                            fill="solid"
                            color="danger"
                            onClick={() => {
                                dispatch(setDeselectAllUsers());
                            }}
                            size="small"
                        >
                            <small>Quitar todos</small>
                            <IonIcon icon={trashOutline} slot="end" />
                        </IonButton>
                    )}
                    <ConfirmButton />
                </IonButtons>
            </IonToolbar>
            <UserSelectedSearchBar />
            <IonContent style={{ overlay: "scroll", height: "60vh" }}>
                <IonList>
                    {findAssignedUsersStatus === "succeeded" && filterSelectedUsers.map((item) => (
                        <IonItem key={item.id}>
                            <IonLabel>
                                <h2 style={{ fontWeight: 700 }}>
                                    <IonText color="primary">{item.user.name}</IonText>
                                </h2>
                                <h4>
                                    <IonText color="medium" style={{ fontWeight: 500 }}>
                                        {item.location.name}
                                    </IonText>
                                </h4>
                            </IonLabel>
                            <IonButton
                                fill="clear"
                                onClick={() => {
                                    dispatch(setDeselectUser(item));
                                }}
                                size="large"
                            >
                                <IonIcon icon={trashOutline} />
                            </IonButton>
                        </IonItem>
                    ))}
                    {findAssignedUsersStatus === "pending" && (
                        <p className="ion-text-center">
                            <IonSpinner />
                        </p>
                    )}
                </IonList>
            </IonContent>
        </IonCard>
    );
};
